module.exports = __webpack_public_path__ + "img/korzysci-sosnowiec-nowybaner-pazdziernik.8c962a95.jpg";